import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import { fetchGamesList, fetchMiscData } from "../../services/axios/apiManager";
import GamesList from "./gamesList";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";
import { useSearchParams } from "react-router-dom";

const Games = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [searchParams] = useSearchParams();
  const [games, setGames] = useState([]);
  const [genres, setGenres] = useState([]);
  const [tagsData, setTagsData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const [genresList, setGenresList] = useState([]);

  const [languages, setLanguages] = useState([]);
  const [pagination, setPagination] = useState({ currentPage: 1, pageSize: 20 });
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Games");
    if (perms) {
      setGranted(perms);
    }
  };

  // // // Fetch Games list
  const fetchGames = async () => {
    const page = searchParams.get("page") || 1;
    const search = searchParams.get("search") || "";
    const status = searchParams.get("status");
    const tag = searchParams.get("tag");
    const language = searchParams.get("language");
    const category = searchParams.get("category");
    const subcategory = searchParams.get("subcategory");
    const type = searchParams.get("type");

    let filterString = "";
    if (search) filterString += `&search=${encodeURIComponent(search)}`;
    if (status && status !== "3") filterString += `&status=${status}`;
    if (tag) filterString += `&tag=${tag}`;
    if (language) filterString += `&language=${language}`;
    if (category) filterString += `&category=${category}`;
    if (subcategory) filterString += `&subcategory=${subcategory}`;
    if (type) filterString += `&type=${type}`;

    const res = await fetchGamesList(
      page,
      pagination.pageSize || 20,
      filterString
    );
    if (res?.data?.success && res?.data?.data) {
      setGames(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      await handleErrors(res, navigate);
    }
  };

  // // // Fetch genres, tags and languages
  const fetchOtherData = async () => {
    const res = await fetchMiscData();
    if (res?.data?.data) {
      const genreData = res?.data?.data?.genres?.map((m) => m.name);
      const genreListData = res?.data?.data?.genres?.map((m) => ({
        label: m.name,
        value: m.name,
      }));
      setGenres(genreData);
      setGenresList(genreListData);
      const tagsTemp = res?.data?.data?.tags;
      setTagsData(tagsTemp);
      setLanguages(res.data.data.languages || []);
      setCategories(res.data.data.categories || []);
      setSubCategories(res.data.data.subCategories || []);
    }
  };

  useEffect(() => {
    extractPermissions();
    fetchOtherData();
  }, []);

  useEffect(() => {
    fetchGames();
  }, [searchParams]);

  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Management</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                    data-testid="gameHeading"
                  >
                    Gaming Platform
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <GamesList
          games={games}
          setGames={setGames}
          setPagination={setPagination}
          genres={genres}
          tagsData={tagsData}
          languages={languages}
          pagination={pagination}
          granted={granted}
          genresList={genresList}
          categories={categories}
          subCategories={subCategories}
        />
      </div>
    </DashboardLayout>
  );
};
export default Games;
